import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastProps } from 'lib/Toaster';
import { v4 as uuidv4 } from 'uuid';
import { NotificationState, ToastPayload } from './types';
import { generateToastMessage } from './utils';

const initialState: NotificationState = [];

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addToastNotification: (state, action: PayloadAction<ToastPayload>) => {
      const id = action.payload.id ?? uuidv4();

      const index = state.findIndex((toast: ToastProps) => toast.id === id);
      if (index > -1) state.splice(index, 1);

      state.push(generateToastMessage({ ...action.payload, id }));
    },
    addNotifications: (state, action: PayloadAction<ToastPayload[]>) => {
      state.push(...action.payload.map((notification) => generateToastMessage({ id: uuidv4(), ...notification })));
    },
    removeToastNotification: (state, action: PayloadAction<string>) => {
      const index = state.findIndex((toast: ToastProps) => toast.id === action.payload);
      if (index > -1) state.splice(index, 1);
    },
    clearNotification: () => {
      return initialState;
    },
  },
});

export const { addToastNotification, addNotifications, removeToastNotification, clearNotification } =
  notificationSlice.actions;

export default notificationSlice.reducer;
